module.exports = __webpack_public_path__ + "static/media/features-split-top-02.216c5cfa.png";